<template>
  <div class="py-5 container-fluid">
    <div id="topinfo">
      <div class="row mt-4 justify-content-center">
        <div class="col-12">
          <div class="mx-auto col-xl-8 col-lg-9 col-md-10 d-flex mb-2 flex-column card card-body blur shadow-blur">
            <div class="card-header mb-0 text-center">
              <h3 class="font-weight-bolder text-success text-gradient">Maintenance</h3>
              <h5
                v-if="coating_booth"
                class="mb-0"
              >
                for Line <i>{{ coating_booth.name }}</i>
              </h5>
            </div>
          </div>
          <div class="mx-auto col-xl-8 col-lg-9 col-md-10 d-flex flex-column card card-body blur shadow-blur">
            <div class="card-header row">
              <h4
                v-if="selected_hopper === null"
                class="text-center mt-1 ms-4"
              >
                Select Hopper
              </h4>
              <label
                v-if="selected_hopper !== null"
                class="mt-2 mb-2"
              >
                Selected Hopper
              </label>
              <div
                class="mt-2 mb-2"
                :style="{ position: 'relative', pointerEvents: hoppers.length === 1 ? 'none' : 'auto' }"
                @click.stop="hoppers.length > 1 && (hopperDropdownVisible = !hopperDropdownVisible)"
              >
                <button class="form-control">
                  {{
                    selected_hopper
                      ? selected_hopper.name
                      : hoppers.length > 0
                        ? "Click here to select a Hopper"
                        : "No Hoppers to select"
                  }}
                </button>
                <div
                  v-if="hopperDropdownVisible"
                  class="dropdown-menu show w-100"
                  style="border: 1px solid #ccc; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1)"
                >
                  <input
                    v-model="searchQueryHopper"
                    class="form-control mt-1 mb-2 ms-2 w-90"
                    type="text"
                    placeholder="Search..."
                    @click.stop
                  />
                  <div
                    v-for="hopper in filteredHoppers"
                    :key="hopper.id"
                    class="dropdown-item"
                    style="cursor: pointer"
                    @click="updateSelectedHopper(hopper)"
                  >
                    {{ hopper.name }}
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="selected_hopper !== null"
              class="card-header row py-0"
            >
              <div
                class="card-body"
                style="padding-top: 0.2rem"
              >
                <h4 class="text-left">Gun status summary</h4>
                <div class="table-responsive">
                  <table class="table text-center table-sm">
                    <thead>
                      <tr>
                        <th class="small">Gun Name</th>
                        <th class="small">Venturi diameter</th>
                        <th
                          v-for="recipe in recipes"
                          :key="recipe.id"
                          class="small"
                        >
                          Recipe <i>{{ recipe.category }}</i>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="gun in gun_data"
                        :key="gun.gun_id"
                        :class="{
                          'hovered-row': hovered_gun === gun.gun_id,
                        }"
                        data-bs-toggle="modal"
                        data-bs-target="#modal-form"
                        @mouseover="hovered_gun = gun.gun_id"
                        @mouseleave="hovered_gun = null"
                        @click="showCurrentGunData(gun.gun_id)"
                      >
                        <td class="small">
                          {{ gun.gun_name }}
                        </td>
                        <td class="small">
                          {{ gun.venturi_diameter || "-" }}
                        </td>
                        <td
                          v-for="recipe in recipes"
                          :key="recipe.id"
                          style="min-width: 120px"
                        >
                          <span :class="`color-box-wide ${getValidationClass(recipe.id, gun.gun_id)}`"></span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="color-legend mb-3">
                  <div class="legend-item">
                    <span class="color-box valid-row"></span>
                    <span>Valid</span>
                  </div>
                  <div class="legend-item">
                    <span class="color-box accepted-row"></span>
                    <span>Change Venturi</span>
                  </div>
                  <div class="legend-item">
                    <span class="color-box rejected-row"></span>
                    <span>Service</span>
                  </div>
                  <div
                    v-if="unknownGunStatus"
                    class="legend-item"
                  >
                    <span class="color-box"></span>
                    <span>Unknown</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="modal-form"
            ref="modal"
            class="modal fade"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modal-form"
            aria-hidden="true"
            style="z-index: 1050 !important"
          >
            <GunDetailModal
              :gun-info="gun_info"
              :gun-dataset="datapoints_gun_detail_modal"
              :gun-recipes="recipes_gun_detail_modal"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import setTooltip from "@/assets/js/tooltip.js";
import GunDetailModal from "./components/GunDetailModal.vue";
import { numericPositiveOnly, roundPowderAmountParameters } from "@/views/composables.js";

export default {
  name: "MaintenanceSteelcase",
  components: {
    GunDetailModal,
  },
  props: {
    lineId: {
      type: String,
      default: "",
    },
  },
  data() {
    this.$i18n.locale = this.$store.state.user_data.language;

    return {
      coating_booth: {},
      hoppers: [],
      unknownGunStatus: false,
      gun_diagnosis_by_recipe_id_by_gun_id: {},
      selected_hopper: null,
      hopperDropdownVisible: false,
      searchQueryHopper: "",
      min_powder_amount_setting: null,
      max_powder_amount_setting: null,
      last_powder_throughput: null,
      powder_amount_settings: [],
      gun_data: [],
      recipes: [],
      current_real_powder_throughput: [],
      current_is_compliant: [],
      hovered_gun: null,
      gun_info: null,
      datapoints_gun_detail_modal: [],
      recipes_gun_detail_modal: [],
    };
  },
  computed: {
    filteredHoppers() {
      return this.hoppers.filter(hopper => hopper.name.toLowerCase().includes(this.searchQueryHopper.toLowerCase()));
    },
  },
  mounted() {
    this.$store.state.isAbsolute = true;
    setTooltip();
    document.addEventListener("click", this.closeDropdown);
    this.getData();
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
  },
  methods: {
    numericPositiveOnly,
    roundPowderAmountParameters,
    async getData() {
      await this.getCoatingBooth();

      this.gun_data = await this.getGuns();
      await this.getHoppers();

      if (this.$route.query.hopper) {
        const query_hopper = this.hoppers.find(hopper => hopper.id == this.$route.query.hopper);
        await this.updateSelectedHopper(query_hopper);
      }

      if (this.selected_hopper != null) {
        await this.getRecipes();
        await this.getGunStatusByRecipe();
      }
    },
    async getCoatingBooth() {
      try {
        var response = await axios.get("api/v1/steelcase/coatingbooth/" + this.lineId + "/");
        this.coating_booth = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    async updateSelectedHopper(hopper) {
      this.searchQueryHopper = "";
      if (this.selected_hopper != hopper) {
        this.selected_hopper = hopper;
        await this.getVenturiDiameters();
        await this.getRecipes();
        await this.getGunStatusByRecipe();

        const selected_recipe_query = this.$route.query.recipe ? { recipe: this.$route.query.recipe } : {};
        this.$router.replace({
          name: "MaintenanceSteelcase",
          params: { lineId: this.lineId },
          query: { hopper: hopper.id, ...selected_recipe_query },
        });
      }
    },
    async getHoppers() {
      if (this.coating_booth.id === null) {
        return;
      }
      try {
        let response = await axios.get("api/v1/steelcase/hopper/coating-booth/" + this.coating_booth.id + "/");
        this.hoppers = response.data;

        if (this.hoppers.length === 1) {
          this.updateSelectedHopper(this.hoppers[0]);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getRecipes() {
      try {
        let response = await axios.get("api/v1/steelcase/recipe/hopper/" + this.selected_hopper.id + "/");
        this.recipes = response.data.filter(recipe => recipe.active);
      } catch (error) {
        console.error(error);
      }
    },
    async getGunStatusByRecipe() {
      this.unknownGunStatus = false;
      this.recipes.forEach(async recipe => {
        try {
          const gun_diagnosis_response = await axios.get(
            `api/v1/steelcase/getlastguninferredstatusforrecipe/coating-booth/${this.coating_booth.id}/recipe/${recipe.id}/`,
          );
          this.gun_diagnosis_by_recipe_id_by_gun_id[recipe.id] = gun_diagnosis_response.data.diagnosis_by_gun_id;
        } catch (error) {
          this.unknownGunStatus = true;
          console.error(error);
        }
      });
      return null;
    },
    async getVenturiDiameters() {
      try {
        if (this.selected_hopper === null) {
          return;
        }

        const response = await axios.get(`api/v1/steelcase/getlatestventuridiameters/${this.selected_hopper.id}/`);

        if (response.data.venturi_diameters_by_gun_id) {
          this.gun_data = this.gun_data.map(gun => {
            const gun_venturi_diameter = response.data.venturi_diameters_by_gun_id[gun.gun_id];
            return gun_venturi_diameter
              ? { ...gun, venturi_diameter: parseFloat(gun_venturi_diameter.toFixed(1)) }
              : gun;
          });
        }
      } catch (error) {
        console.error(error);
        this.$swal({
          title: "Error",
          text: `Failed to fetch venturi nozzle diameters.`,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    },
    async showCurrentGunData(gun_id) {
      try {
        const response_coefficients = await axios.get(
          `api/v1/steelcase/getlatestgunmodelcoefficientsinferred/coating-booth/${this.coating_booth.id}/hopper/${this.selected_hopper.id}/gun/${gun_id}/`,
        );
        const coefficients = response_coefficients.data.latest_gun_model_coefficients;

        let response_datapoints = await axios.post("api/v1/steelcase/computelogisticdiagrampergun/", {
          coating_booth_id: this.coating_booth.id,
          data: {
            gun_id: {
              L: coefficients.L,
              k: coefficients.k,
              x0: coefficients.x0,
            },
          },
        });

        this.gun_info = this.gun_data.find(gun => gun.gun_id == gun_id);
        this.datapoints_gun_detail_modal = response_datapoints.data;
        this.recipes_gun_detail_modal = this.recipes;
      } catch (error) {
        console.error(error);
        this.gun_info = null;
        this.datapoints_gun_detail_modal = [];
        this.recipes_gun_detail_modal = [];
      }
    },
    getValidationClass(recipe_id, gun_id) {
      if (
        !this.gun_diagnosis_by_recipe_id_by_gun_id ||
        this.gun_diagnosis_by_recipe_id_by_gun_id.length == 0 ||
        this.gun_diagnosis_by_recipe_id_by_gun_id[recipe_id] == null
      ) {
        return "";
      }
      const diagnosis = this.gun_diagnosis_by_recipe_id_by_gun_id[recipe_id][gun_id];

      if (diagnosis == null || diagnosis == undefined || diagnosis == "") {
        return "";
      }

      switch (diagnosis) {
        case "success":
          return "valid-row";
        case "change venturi diameter":
          return "accepted-row";
        case "failure":
          return "rejected-row";
        default:
          return "";
      }
    },
    enrichGunData(gunData) {
      const gun = { ...gunData };
      gun.gun_id = gunData.id;
      gun.gun_name = gunData.name;
      gun.L = null;
      gun.k = null;
      gun.x0 = null;
      gun.diagnosis = null;
      gun.real_throughput = null;
      gun.recipes = null;
      return gun;
    },
    getGuns() {
      try {
        const guns_array = [
          ...this.coating_booth.reciprocator_side_A.guns,
          ...this.coating_booth.reciprocator_side_B.guns,
          ...(this.coating_booth.reciprocator_side_bottom ? this.coating_booth.reciprocator_side_bottom.guns : []),
        ];

        const enriched_guns = guns_array.map(gunData => this.enrichGunData(gunData));
        enriched_guns.sort((a, b) => a.gun_index - b.gun_index);

        return enriched_guns;
      } catch (error) {
        console.error(error);
      }
    },
    closeDropdown() {
      this.hopperDropdownVisible = false;
    },
  },
};
</script>
<style scoped>
.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.container-fluid {
  padding-top: 20px;
}

.valid-row {
  background-color: #d4edda !important; /* green */
}
.accepted-row {
  background-color: #fff3cd !important; /* yellow */
}
.rejected-row {
  background-color: #f8d7da !important; /* red */
}
.hovered-row {
  background-color: #f5f5f7 !important; /* gray */
  font-weight: bold;
}

.color-legend {
  display: flex;
  gap: 15px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  font-size: 0.9rem;
}

.legend-item {
  display: flex;
  align-items: center;
}

.color-box {
  width: 20px;
  height: 20px;
  display: inline-block;
  border-radius: 3px;
  margin-right: 6px;
  border: 1px solid #ccc;
}

.color-box-wide {
  width: 120px;
  height: 22px;
  display: inline-block;
  border-radius: 3px;
  margin-right: 6px;
  border: 1px solid #ccc;
}
</style>
